export default __webpack_public_path__ + "static/media/Islanders.1e06a83a.png";